import { LevelType } from '../types/Level';

export interface TypeStat {
  // How many levels of this type exist
  count: number;
  // How many levels have been added since this type last appeared; null when it never has
  sinceLast: number | null;
}

// A type is overdue once this many levels have passed without it
export const STALE_AFTER = 5;

export const isStale = (stat: TypeStat): boolean => stat.sinceLast === null || stat.sinceLast >= STALE_AFTER;

// Levels are numbered in play order, so "since last" is the gap between the newest level
// overall and the newest level of that type.
export const typeStats = (levels: { id: string; levelType: LevelType }[]): Record<LevelType, TypeStat> => {
  const numbers = levels.map(level => parseInt(level.id, 10)).filter(number => !isNaN(number));
  const newest = numbers.length > 0 ? Math.max(...numbers) : null;

  const stats = {} as Record<LevelType, TypeStat>;
  (Object.values(LevelType) as LevelType[]).forEach(type => {
    const ofType = levels.filter(level => level.levelType === type);
    const typeNumbers = ofType.map(level => parseInt(level.id, 10)).filter(number => !isNaN(number));
    stats[type] = {
      count: ofType.length,
      sinceLast: newest !== null && typeNumbers.length > 0 ? newest - Math.max(...typeNumbers) : null,
    };
  });
  return stats;
};
